export interface Events {
  [key: string]: string;
}

export const eventsRegistry: Events = {
  backButtonPressed: 'back-button-pressed',
};
